import { render, staticRenderFns } from "./PropertyPoiForm.vue?vue&type=template&id=f5e778d2&scoped=true&"
import script from "./PropertyPoiForm.vue?vue&type=script&lang=js&"
export * from "./PropertyPoiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e778d2",
  null
  
)

export default component.exports